import { useEffect } from 'react';
import { Bell } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useNotificationStore } from '@store/notificationStore';

const NotificationBell = () => {
    const navigate = useNavigate();
    const unreadCount = useNotificationStore((state) => state.unreadCount);
    const fetchUnreadCount = useNotificationStore((state) => state.fetchUnreadCount);

    // Poll for unread count every 30 seconds
    useEffect(() => {
        fetchUnreadCount();
        const interval = setInterval(fetchUnreadCount, 30000);
        return () => clearInterval(interval);
    }, [fetchUnreadCount]);

    return (
        <button
            onClick={() => navigate('/dashboard/notifications')}
            className="relative flex items-center gap-1.5 md:gap-2 px-2.5 md:px-4 h-8 md:h-auto md:py-2 bg-white/[0.08] border border-white/20 rounded-full hover:bg-white/[0.15] hover:border-purple-400/50 transition-colors duration-200 group cursor-pointer"
        >
            <Bell size={16} className="md:w-3.5 md:h-3.5 text-purple-300 group-hover:text-purple-200 transition-colors" />
            <span className="hidden sm:block text-xs md:text-sm font-bold text-white group-hover:text-purple-50 tracking-wide transition-colors">
                Notify
            </span>
            {unreadCount > 0 && (
                <span className="absolute -top-1 -right-1 md:-top-1.5 md:-right-1.5 flex items-center justify-center min-w-[18px] h-[18px] md:min-w-[20px] md:h-[20px] bg-gradient-to-r from-red-500 to-pink-500 text-white text-[9px] md:text-[10px] font-bold rounded-full border-2 border-cosmic-900 shadow-lg animate-pulse px-1">
                    {unreadCount > 99 ? '99+' : unreadCount}
                </span>
            )}
        </button>
    );
};

export default NotificationBell;
